module.exports = __webpack_public_path__ + "static/phone-1b-5c96204167958403a38b60ff4c26cebb.svg";